(function() {
  /*
   * Polyfill CanvasRenderingContext2D.resetTransform
   *
   * https://github.com/azerion/phaser-spine/tree/spine-ts Canvas resize makes use of resetTransform
   * which doesn't have full browser support yet.
   * see https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/resetTransform
   *
   * Issue raised here:
   * https://projects.pbs.org/bitbucket/projects/EWW/repos/hide-and-seek/pull-requests/3/overview
   *
   */

  if (!('resetTransform' in CanvasRenderingContext2D.prototype)) {
    CanvasRenderingContext2D.prototype.resetTransform = function() {
      this.setTransform(1, 0, 0, 1, 0, 0);
    };
  }
})();
